import { z } from 'zod';
export var EvaluationMetadata = z.object({
  type: z.literal('evaluation_metadata'),
  attributes: z.object({
    rejectionOptions: z.array(z.object({
      code: z.string(),
      displayName: z.string()
    })),
    checkDefinitions: z.array(z.object({
      code: z.string(),
      displayName: z.string(),
      results: z.array(z.object({
        code: z["enum"](['positive', 'negative', 'warning']),
        displayName: z.string()
      })),
      feedbackOptions: z.array(z.object({
        code: z.string(),
        displayName: z.string()
      }))
    }))
  })
});